import React from 'react';
import {connect} from 'react-redux';

import {CardDisplay} from '../utils/CardDisplay';
import Card from '../utils/Card';
import Repeater from '@Utils/Repeater';
import {AppState} from "@Redux/store";
import {Dispatch} from "@Redux/type";
import { opponentTeamArmies } from '@Selectors/tool/pairing/opponentTeamArmy';
import {TeamArmyView} from "@Selectors/tool/pairing/create/view/TeamArmyView";
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

const OpponentTeam: React.FC<OpponentTeamProps> = ({ hasArmy, name, armies }) => {
  if(!hasArmy){
    return (
      <div></div>
    );
  }

  return (
    <div>
      <h3 className="text-center"><FormattedMessage {...defaultMessages.toolPairingOpponentTeamTeam} /> {name}</h3>
      <div className="row list-armies justify-content-center">
      <Repeater data={armies} indexPrefix='army'> 
          {
            (item: TeamArmyView) =>
            <Card display={CardDisplay.HIDDEN} />
          }
        </Repeater>
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  hasArmy: (state.opponentTeam.entity?.teamArmies?.length ?? 0) > 0,
  name: state.opponentTeam.entity?.name ?? '',
  armies: opponentTeamArmies(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(OpponentTeam);

type OpponentTeamProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
